export const selectCities = (state) => state.fees.cities;
export const selectCountries = (state) => state.fees.countries;
export const selectStates = (state) => state.fees.states;
export const selectVinData = (state) => state.fees.vinData;
export const selectFeesResponse = (state) => state.fees.response;
export const selectFeeLoadingState = (state) => state.fees.isLoading;
export const selectFeesFormData = (state) => state.fees.formData;
export const selectFeesError = (state) => state.fees.feesError;
